import type { SingleOption } from '@frontend/basic-forms';
import { SetURLSearchParams } from 'react-router-dom';

export function mapResultSetToOptions<T extends { id: string }>(result: T[], labels: (item: T) => string): SingleOption<T>[] {
    return result.map((item) => ({
        value: item.id,
        label: labels(item) ?? item.id,
        metadata: item
    }));
}

export function mapResultSetToMappedOptions<T extends { id: string }>(
    result: T[],
    mapKey: keyof T,
    labels: (item: T) => string
): { label: string; options: { value: any; label: string }[] }[] {
    const groupedItems: { label: string; options: { value: any; label: string }[] }[] = [];

    result.forEach((item) => {
        if (item[mapKey] && groupedItems.find((g) => g.label === item[mapKey])) {
            groupedItems.find((g) => g.label === item[mapKey])?.options.push({ value: item.id, label: labels(item) ?? item.id });
        } else {
            groupedItems.push({ label: item[mapKey] as string, options: [{ value: item.id, label: labels(item) ?? item.id }] });
        }
    });

    return groupedItems;
}

export const onQueryParamChange = (value: string | null, key: string, setSearchParams: SetURLSearchParams) => {
    if (value && key) {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            if (params.has(key)) {
                params.set(key, value);
            } else {
                params.append(key, value);
            }
            return params;
        });
    } else if (key) {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.delete(key);
            return params;
        });
    }
};
